module.exports = "<div class=\"row-navigation\" #navigationContainer>\n    <ng-container *ngFor=\"let nav of rowNavigation; index as i;\">\n        <span (click)=\"clickNavItem(i)\" [class.active]=\"nav.active\">{{nav.title}}</span>\n    </ng-container>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/mobile-navigation/mobile-content-navigation.template.html
// module id = 722
// module chunks = 2